import { REQUEST_EXAMPLE_DATA } from '../constants/actionTypes';

const INITIAL_STATE = { posts: {}, errors: null };

export default function example(state=INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_EXAMPLE_DATA:
      return { ...state, posts: action.payload.data, errors: null }
    default:
      return state;
  }
}
